import { changeFontSize, changeLanguage, changeTheme } from '../../app/reducer';
import {
  clearLocalStorage,
  isOpenSpecificComponent,
} from '../../helpers/Common';
import { saveLanguage } from '../../helpers/Language';
import reducerRegistry from '../../helpers/ReducerRegistry';
import LayoutHelper from '../../helpers/Layout';
import { setHeadlineCodes } from '../header/middle/notifi-maque/reducer';
import { exportToImg } from './../../helpers/Export';
import userSettingService from './../../../core/services/Common/UserSettingService';
import { formatData } from './../../helpers/Api';
import { nameSaveStateDefault } from './../../../configs/LayoutConfig';
import { cloneDeep } from 'lodash';
import Const from './Const';
import SystemSettingConst from './../sidebar/save-system-setting/Const';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';
import authProvider from '../../../core/AuthenticationProvider';
import { I18n } from 'react-redux-i18n';

const REDUCER_NAME = `MAIN_LAYOUT:SIDEBAR:`;
const TOGGLE_SAVE_LAYOUT_POPUP = `${REDUCER_NAME}TOGGLE_SAVE_LAYOUT_POPUP`;
const SHOW_HIDE_SAVE_LAYOUT_POPUP = `${REDUCER_NAME}SHOW_HIDE_SAVE_LAYOUT_POPUP`;
const FETCH_LIST_WORKSPACE = `${REDUCER_NAME}FETCH_LIST_WORKSPACE`;
const SET_LOADING_WORKSPACE = `${REDUCER_NAME}SET_LOADING_WORKSPACE`;
const APPEND_WORKSPACE = `${REDUCER_NAME}APPEND_WORKSPACE`;
const REMOVE_WORKSPACE = `${REDUCER_NAME}REMOVE_WORKSPACE`;
const TOGGLE_CONFIRM_REMOVE_WORKSPACE = `${REDUCER_NAME}TOGGLE_CONFIRM_REMOVE_WORKSPACE`;
const SHOW_CONFIRM_REMOVE_WORKSPACE = `${REDUCER_NAME}SHOW_CONFIRM_REMOVE_WORKSPACE`;
const TOGGLE_SAVE_SYSTEM_SETTING = `${REDUCER_NAME}TOGGLE_SAVE_SYSTEM_SETTING`;
const CHANGE_TIME_ZONE = `${REDUCER_NAME}CHANGE_TIME_ZONE`;
const FETCH_DATA_SYSTEM_SETTING = `${REDUCER_NAME}FETCH_DATA_SYSTEM_SETTING`;
const SET_LOADING_SYSTEM_SETTING = `${REDUCER_NAME}SET_LOADING_SYSTEM_SETTING`;
const TOGGLE_SHOW_INFO_USER = `${REDUCER_NAME}TOGGLE_SHOW_INFO_USER`;
const FETCH_DATA_USER_INFO = `${REDUCER_NAME}FETCH_DATA_USER_INFO`;
const SAVE_INFO_CHECKED_PERSONAL = `${REDUCER_NAME}SAVE_INFO_CHECKED_PERSONAL`;
const SHOW_HIDE_EXCEL = `${REDUCER_NAME}SHOW_HIDE_EXCEL`;
const NOTIFY_SAVE_LAYOUT_POPUP = `${REDUCER_NAME}NOTIFY_SAVE_LAYOUT_POPUP`;
const TOGGLE_LOGOUT_POPUP = `${REDUCER_NAME}TOGGER_LOGOUT_POPUP`;
const EDIT_WORKSPACE = `${REDUCER_NAME}EDIT_WORKSPACE`;
const TOGGLE_VALIDATE_WORKSPACE_NAME = `${REDUCER_NAME}TOGGLE_VALIDATE_WORKSPACE_NAME`;
const UPDATE_NOTIFICATION_SUBSCRIBED = `${REDUCER_NAME}UPDATE_NOTIFICATION_SUBSCRIBED`;
export const NOTIFICATION_SUBSCRIBED_KEY = 'NOTIFICATION_SUBSCRIBED_KEY';

const contactMethod = {
  both: 'Both',
  email: 'Email',
  mobilePhone: 'MobilePhone',
};

export {
  reducer as default,
  REDUCER_NAME,
  toggleSaveLayoutPopup,
  actionSaveLayoutPopup,
  fetchDataWorkspace,
  fetchInitDataWorkspace,
  setLoading,
  deleteWorkspace,
  confirmRemoveWorkspace,
  showConfirmRemoveWorkspace,
  toggleSaveSystemSetting,
  changeTimeZone,
  fetchDataSystemSetting,
  callApiSystemSetting,
  saveLayout,
  toggleShowInfoUser,
  fetchDataUserInfo,
  updateUserSetting,
  saveInfoCheckedPersonalSetting,
  showHideExcel,
  notifySaveLayoutPopup,
  toggleLogoutPopup,
  editWorkspace,
  toggleShowValidateWorkspaceName,
  toggleConfirmRemoveWorkspace,
  updateNotificationSubscribed,
  getWatchlistUserSetting,
  getUserSettingState,
};

function getWatchlistUserSetting(state) {
  const wlSetting =
    state[REDUCER_NAME].settingSystem.dataSystem &&
    state[REDUCER_NAME].settingSystem.dataSystem.watchListSetting;
  if (!wlSetting) {
    return wlSetting;
  }
  try {
    return JSON.parse(wlSetting);
  } catch (e) {
    return wlSetting;
  }
}

function getUserSettingState(state) {
  return state[REDUCER_NAME].settingSystem.dataSystem;
}

function updateNotificationSubscribed(subscribed) {
  localStorage.setItem(NOTIFICATION_SUBSCRIBED_KEY, subscribed);

  return {
    type: UPDATE_NOTIFICATION_SUBSCRIBED,
    payload: subscribed,
  };
}

function toggleShowValidateWorkspaceName(
  isShowPopup = false,
  title,
  message = [],
) {
  if (isShowPopup) {
    return {
      type: TOGGLE_VALIDATE_WORKSPACE_NAME,
      payload: {
        isShowValidateWorkspaceName: isShowPopup,
        title,
        message,
      },
    };
  }
  return {
    type: TOGGLE_VALIDATE_WORKSPACE_NAME,
  };
}

function toggleLogoutPopup(isLogout) {
  return dispatch => {
    dispatch({
      type: TOGGLE_LOGOUT_POPUP,
    });
    if (isLogout) {
      clearLocalStorage();
      authProvider.signout();
    }
  };
}

function toggleSaveLayoutPopup() {
  return {
    type: TOGGLE_SAVE_LAYOUT_POPUP,
  };
}

function toggleSaveSystemSetting() {
  return {
    type: TOGGLE_SAVE_SYSTEM_SETTING,
  };
}

function toggleShowInfoUser() {
  return {
    type: TOGGLE_SHOW_INFO_USER,
  };
}

function changeTimeZone(timeZone) {
  return dispatch => {
    dispatch({
      type: CHANGE_TIME_ZONE,
      payload: {
        timeZone,
      },
    });
  };
}

function updateUserSetting(data) {
  return {
    type: FETCH_DATA_SYSTEM_SETTING,
    payload: {
      data,
    },
  };
}

function fetchDataSystemSetting() {
  return dispatch => {
    userSettingService.getUserSettings().then(response => {
      const tmpData = formatData(response);
      const data = tmpData.length > 0 ? tmpData[0] : {};
      if (data.language) {
        dispatch(changeLanguage(data.language));
        saveLanguage(data.language);
      }
      if (data.theme) {
        dispatch(changeTheme(data.theme));
      }
      if (data.fontSize) {
        dispatch(changeFontSize(data.fontSize));
      }
      dispatch(updateUserSetting(data));
      if (data.marqueeOrganCodes) {
        dispatch(setHeadlineCodes(JSON.parse(data.marqueeOrganCodes)));
      }
    });
  };
}

function fetchDataUserInfo(infoUser) {
  return dispatch => {
    dispatch({
      type: FETCH_DATA_USER_INFO,
      payload: {
        infoUser,
      },
    });
  };
}

function callApiSystemSetting(dataInput) {
  return dispatch => {
    const params = {
      ...dataInput,
    };
    dispatch(setLoading(SET_LOADING_SYSTEM_SETTING, true));
    userSettingService.updateUserSettings(params).then(response => {
      if (response) {
        dispatch(setLoading(SET_LOADING_SYSTEM_SETTING, false));
        dispatch(updateUserSetting(params));
      }
    });
  };
}

function saveInfoCheckedPersonalSetting(listChecked) {
  return dispatch => {
    dispatch({
      type: SAVE_INFO_CHECKED_PERSONAL,
      payload: {
        listChecked,
      },
    });
  };
}

function fetchDataWorkspace(params = {}) {
  return dispatch => {
    dispatch(setLoading(SET_LOADING_WORKSPACE, true));
    return userSettingService.getWorkspace(params).then(response => {
      const listWorkspace = formatData(response);
      dispatch(setLoading(SET_LOADING_WORKSPACE, false));
      dispatch({
        type: FETCH_LIST_WORKSPACE,
        payload: getWorkspaceByTypeCode(listWorkspace),
      });

      return listWorkspace;
    });
  };
}

function fetchInitDataWorkspace(params = {}) {
  return dispatch => {
    dispatch(setLoading(SET_LOADING_WORKSPACE, true));
    return userSettingService.getInitWorkspace(params).then(response => {
      const listWorkspace = formatData(response);
      dispatch(setLoading(SET_LOADING_WORKSPACE, false));
      dispatch({
        type: FETCH_LIST_WORKSPACE,
        payload: getWorkspaceByTypeCode(listWorkspace),
      });

      return listWorkspace;
    });
  };
}

function createNewWorkspace(
  name = Const.CURRENT_WORKSPACE_NAME,
  thumbnails = '',
  description = '',
  isActive = false,
  callback = () => {},
) {
  const config = LayoutHelper.getStateFromConfig(currentState.getAll());
  LayoutHelper.saveState(nameSaveStateDefault, config);

  const params = {
    name,
    workspace: config,
    thumbnails,
    description,
    isActive,
  };

  userSettingService.newWorkspace(params).then(response => {
    callback(response, params);
  });
}

function saveLayout() {
  return (dispatch, getState) => {
    const config = LayoutHelper.getStateFromConfig(currentState.getAll());
    if (typeof config !== 'string' || isOpenSpecificComponent()) {
      return;
    }
    const user = getState().userInfo;
    LayoutHelper.saveState(nameSaveStateDefault, config);
    if (!Object.keys(user).length) {
      return;
    }
    const currentWorkspace = getState()[REDUCER_NAME].saveLayout
      .currentWorkspace;
    if (!Object.keys(currentWorkspace).length) {
      createNewWorkspace();
    } else {
      userSettingService.updateWorkspace({
        workspaceId: currentWorkspace.workspaceId,
        workspace: config,
        name: Const.CURRENT_WORKSPACE_NAME,
      });
    }
  };
}

const resizeImage = base64 =>
  new Promise(resolve => {
    const width = 310;
    const height = 166;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    const image = new Image();
    image.onload = () => {
      ctx.drawImage(image, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.8));
    };
    image.src = base64;
  });

function actionSaveLayoutPopup(isApply, name, chartingImages) {
  return (dispatch, getState) => {
    dispatch(showHideSaveLayoutPopup(false));

    if (isApply) {
      exportToImg(
        'goldenLayout',
        name,
        null,
        null,
        async thumbnails => {
          const compressedThumb = await resizeImage(thumbnails);
          createNewWorkspace(
            name,
            compressedThumb,
            '',
            true,
            (response, params) => {
              if (response) {
                const { status, result, errors } = response;

                if (status === ConstCommon.RESPONSE_STATUS.SUCCESS && result) {
                  dispatch(
                    appendWorkspace({
                      ...params,
                      workspaceId: result,
                      typeCode: Const.TYPE_WORKSPACE.USER,
                    }),
                  );
                } else if (
                  status === ConstCommon.RESPONSE_STATUS.FAILED &&
                  !result
                ) {
                  dispatch(
                    notifySaveLayoutPopup(
                      true,
                      errors,
                      I18n.t(`message.titleErrorCreateNewLayout`),
                    ),
                  );
                }
              }
            },
          );
        },
        0.5,
        chartingImages,
      );
    }
  };
}

function notifySaveLayoutPopup(
  isShow,
  messages = [],
  title = 'System error save Layout',
) {
  return {
    type: NOTIFY_SAVE_LAYOUT_POPUP,
    payload: {
      title,
      isShow,
      messages,
    },
  };
}

function showHideSaveLayoutPopup(isShowPopup) {
  return {
    type: SHOW_HIDE_SAVE_LAYOUT_POPUP,
    payload: {
      isShowPopup,
    },
  };
}

function appendWorkspace(workspace) {
  return {
    type: APPEND_WORKSPACE,
    payload: {
      workspace,
    },
  };
}

function deleteWorkspace(workSpaceId) {
  return dispatch => {
    userSettingService.deleteWorkspace({ workSpaceId }).then(response => {
      dispatch(removeWorkspace(workSpaceId));
    });
  };
}

function getWorkspaceSaveToServer(listWorkspaceUser, workspaceId, name) {
  let workspaceSaveToServer = {};
  listWorkspaceUser.forEach(item => {
    if (item.workspaceId === workspaceId) {
      workspaceSaveToServer = item;
    }
  });
  return {
    workspaceId: workspaceId,
    name: name,
    workspace: workspaceSaveToServer.workspace,
    description: workspaceSaveToServer.description,
    thumbnails: workspaceSaveToServer.thumbnails,
    isActive: workspaceSaveToServer.isActive,
  };
}

function editWorkspace(name, workspaceId) {
  return (dispatch, getState) => {
    const listWorkspaceUser = getState()[REDUCER_NAME].saveLayout
      .listWorkspaceUser;
    dispatch({
      type: EDIT_WORKSPACE,
      payload: {
        name,
        workspaceId,
      },
    });
    userSettingService
      .updateWorkspace(
        getWorkspaceSaveToServer(listWorkspaceUser, workspaceId, name),
      )
      .then(response => {
        if (response) {
          const { status, errors } = response;
          if (status === ConstCommon.RESPONSE_STATUS.FAILED) {
            dispatch(
              toggleShowValidateWorkspaceName(
                true,
                'message.server_error_modify_workspace',
                errors,
              ),
            );
          }
        }
      });
  };
}

function removeWorkspace(workspaceId) {
  return {
    type: REMOVE_WORKSPACE,
    payload: {
      workspaceId,
    },
  };
}

function setLoading(type, isLoading) {
  return {
    type,
    payload: {
      isLoading,
    },
  };
}

function confirmRemoveWorkspace(isApply) {
  return (dispatch, getState) => {
    if (isApply) {
      const workspaceId = getState()[REDUCER_NAME].saveLayout.removeWorkSpaceId;
      dispatch(deleteWorkspace(workspaceId));
    }
    dispatch(toggleConfirmRemoveWorkspace(false));
  };
}

function showConfirmRemoveWorkspace(workspaceId) {
  return {
    type: SHOW_CONFIRM_REMOVE_WORKSPACE,
    payload: {
      workspaceId,
    },
  };
}

function toggleConfirmRemoveWorkspace(isShow) {
  return {
    type: TOGGLE_CONFIRM_REMOVE_WORKSPACE,
    payload: {
      isShow,
    },
  };
}

function showHideExcel(isShow) {
  return {
    type: SHOW_HIDE_EXCEL,
    payload: {
      isShow,
    },
  };
}

function getDefaultNotificationSubscribed() {
  try {
    return JSON.parse(localStorage.getItem(NOTIFICATION_SUBSCRIBED_KEY));
  } catch (e) {
    return true;
  }
}

const initialState = {
  notifySaveLayout: {
    isShow: false,
    messages: [],
    title: null,
  },
  saveLayout: {
    isShowPopup: false,
    listWorkspaceUser: [],
    listWorkspaceSystem: [],
    currentWorkspace: {},
    isLoading: false,
    isShowConfirmRemoveWorkspace: false,
    removeWorkSpaceId: null,
    workspaceValidate: {
      isShowValidateWorkspaceName: false,
      title: '',
      messages: [],
    },
  },
  settingSystem: {
    isShowPopupSystemSetting: false,
    dataSystem: {
      timeFormat: 'English (UK)',
      timeZone: SystemSettingConst.defaultTimeZone,
      notificationSubscribed: getDefaultNotificationSubscribed(),
      newsEmailSubscribed: false,
      notificationEmailSubscribed: false,
    },
    isLoading: true,
  },
  userInfo: {
    isShowInfoUser: false,
    email: true,
    mobilephone: false,
    userInfoSystem: {},
    isShowPopupLogout: false,
  },
  excel: {
    isShow: false,
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case NOTIFY_SAVE_LAYOUT_POPUP:
      const { title, isShow, messages } = action.payload;

      return {
        ...state,
        notifySaveLayout: {
          ...state.notifySaveLayout,
          title,
          isShow,
          messages,
        },
      };
    case FETCH_DATA_USER_INFO:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          userInfoSystem: action.payload.infoUser,
        },
      };

    case FETCH_DATA_SYSTEM_SETTING:
      const { data } = action.payload;
      let email = false;
      let mobilephone = false;
      if (data.contactMethod === contactMethod.both) {
        email = true;
        mobilephone = true;
      } else {
        if (data.contactMethod === contactMethod.email) {
          email = true;
        } else {
          mobilephone = true;
        }
      }

      return {
        ...state,
        settingSystem: {
          ...state.settingSystem,
          dataSystem: {
            ...state.settingSystem.dataSystem,
            ...action.payload.data,
          },
          isLoading: false,
        },
        userInfo: {
          ...state.userInfo,
          email,
          mobilephone,
        },
      };

    case SET_LOADING_SYSTEM_SETTING:
      return {
        ...state,
        settingSystem: {
          ...state.settingSystem,
          ...action.payload,
        },
      };
    case CHANGE_TIME_ZONE:
      return {
        ...state,
        settingSystem: {
          ...state.settingSystem,
          dataSystem: {
            ...state.settingSystem.dataSystem,
            timeZone: action.payload.timeZone,
          },
        },
      };

    case SHOW_CONFIRM_REMOVE_WORKSPACE:
      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          removeWorkSpaceId: action.payload.workspaceId,
          isShowConfirmRemoveWorkspace: true,
        },
      };

    case TOGGLE_CONFIRM_REMOVE_WORKSPACE:
      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          isShowConfirmRemoveWorkspace: action.payload.isShow,
        },
      };

    case TOGGLE_SAVE_LAYOUT_POPUP:
      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          isShowPopup: !state.saveLayout.isShowPopup,
        },
      };

    case TOGGLE_VALIDATE_WORKSPACE_NAME:
      if (action.payload) {
        return {
          ...state,
          saveLayout: {
            ...state.saveLayout,
            workspaceValidate: action.payload,
          },
        };
      }
      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          workspaceValidate: {
            ...state.saveLayout.workspaceValidate,
            isShowValidateWorkspaceName: false,
            title: '',
            message: [],
          },
        },
      };

    case TOGGLE_LOGOUT_POPUP:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          isShowPopupLogout: !state.userInfo.isShowPopupLogout,
        },
      };

    case TOGGLE_SAVE_SYSTEM_SETTING:
      return {
        ...state,
        settingSystem: {
          ...state.settingSystem,
          isShowPopupSystemSetting: !state.settingSystem
            .isShowPopupSystemSetting,
        },
      };

    case TOGGLE_SHOW_INFO_USER:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          isShowInfoUser: !state.userInfo.isShowInfoUser,
        },
      };

    case SHOW_HIDE_SAVE_LAYOUT_POPUP:
    case FETCH_LIST_WORKSPACE:
    case SET_LOADING_WORKSPACE:
      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          ...action.payload,
        },
      };

    case APPEND_WORKSPACE:
      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          listWorkspaceUser: [
            ...cloneDeep(state.saveLayout.listWorkspaceUser),
            action.payload.workspace,
          ],
        },
      };

    case EDIT_WORKSPACE:
      const { name, workspaceId } = action.payload;
      const { listWorkspaceUser: filterListWorkspace } = state.saveLayout;

      let cloneListWorkspaceUser = filterListWorkspace;
      cloneListWorkspaceUser.forEach(item => {
        if (item.workspaceId === workspaceId) {
          item.name = name;
        }
      });

      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          listWorkspaceUser: cloneListWorkspaceUser,
        },
      };

    case REMOVE_WORKSPACE:
      const listWorkspaceUser = cloneDeep(
        state.saveLayout.listWorkspaceUser,
      ).filter(item => {
        return item.workspaceId !== action.payload.workspaceId;
      });

      return {
        ...state,
        saveLayout: {
          ...state.saveLayout,
          listWorkspaceUser,
        },
      };

    case SAVE_INFO_CHECKED_PERSONAL:
      const { listChecked } = action.payload;
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          email: listChecked.email,
          mobilephone: listChecked.mobilephone,
        },
      };
    case UPDATE_NOTIFICATION_SUBSCRIBED:
      return {
        ...state,
        settingSystem: {
          ...state.settingSystem,
          dataSystem: {
            ...state.settingSystem.dataSystem,
            notificationSubscribed: action.payload,
          },
        },
      };
    case SHOW_HIDE_EXCEL:
      return {
        ...state,
        excel: {
          ...state.excel,
          ...action.payload,
        },
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);

function getWorkspaceByTypeCode(data) {
  const listWorkspaceUser = [];
  const listWorkspaceSystem = [];
  let currentWorkspace = {};

  data.forEach(item => {
    if (item.name === Const.CURRENT_WORKSPACE_NAME) {
      currentWorkspace = item;
    } else if (item.typeCode === Const.TYPE_WORKSPACE.SYSTEM) {
      listWorkspaceSystem.push(item);
    } else if (item.typeCode === Const.TYPE_WORKSPACE.USER) {
      listWorkspaceUser.push(item);
    }
  });

  return {
    listWorkspaceSystem,
    listWorkspaceUser,
    currentWorkspace,
  };
}
